<script setup lang="ts">
import { ButtonV2 } from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import {
  useGlobalDependencyProvider,
  type UpgradeSource,
} from '@teachino/shared-util';

const di = useGlobalDependencyProvider();
const router = di.inject('router');

defineProps<{ source: UpgradeSource }>();
</script>

<template>
  <div
    data-testid="upgrade-required-banner"
    class="to-primary-50/40 flex flex-col gap-4 rounded-xl border border-slate-200/80 bg-gradient-to-br from-slate-50 via-white p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="min-w-0 flex-1">
      <slot name="message" :upgrade="router.upgrade" />
    </div>
    <ButtonV2
      class="w-full shrink-0 sm:w-auto"
      variant="primary"
      size="sm"
      icon="sparkle"
      :label="$t('generic_upgrade')"
      @click="router.upgrade()"
    />
  </div>
</template>
